// src/services/facebookPixel.js
let lastTrackedEvents = {};

export default {
  // ...其他方法
  
  track(event, options = {}, allowDuplicate = false) {
    if (!window.fbq) {
      console.warn('Facebook Pixel not loaded');
      return;
    }
    
    if (!allowDuplicate && lastTrackedEvents[event]) {
      console.log(`Event ${event} already tracked. Use trackCustom or set allowDuplicate to true`);
      return;
    }
    
    // 添加唯一事件ID确保可以重复跟踪
    const eventOptions = {
      ...options,
      eventID: options.eventID || `${event}_${Date.now()}`
    };
    
    window.fbq('track', event, eventOptions);
    lastTrackedEvents[event] = true;
  },
  
  forceTrack(event, options = {}) {
    this.track(event, options, true);
  },
  
  clearEventMemory(eventName) {
    if (eventName) {
      delete lastTrackedEvents[eventName];
    } else {
      lastTrackedEvents = {};
    }
  }
};